import axios from 'axios'
import { Linking, Platform, Alert } from 'react-native'
import moment from 'moment'
import { global } from '../const'

import localize from '../localize'

export const onException = (exc, method) => {
  if (global.IS_DEBUG) console.warn(exc, method)
}

export const openLink = (url) => {
  if (global.isNative) { return Linking.openURL(url) }
  return window.open(url, '_blank')
}

export const randomString = (length) => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < length; i++) { text += possible.charAt(Math.floor(Math.random() * possible.length)) }
  return text
}

export const externalServerRequest = async (url, request) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get(url, { params: request })
      resolve(response.data)
    } catch (error) {
      console.log('Server Request: ', error)
      reject(error)
    }
  })
}

export const getServerResponse = async (request) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.get('', { params: request })
      resolve(response.data)
    } catch (error) {
      console.log('Server Request: ', error)
      reject(error)
    }
  })
}

export const getPostServerResponse = async (request) => {
  try {
    let response
    if (Platform.OS === 'android') {
      response = await axios.post('', request)
    } else {
      const dataForm = new FormData()
      Object.keys(request).forEach(key => dataForm.append(key, request[key]))

      response = await axios('', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: dataForm
      })
    }

    return response.data
  } catch (error) {
    console.log(error)
  }
}

export const convertDateTime = (date, status) => {
  const today = new Date()
  const yesterday = new Date(); yesterday.setDate(today.getDate() - 1)
  if (date.toLocaleDateString() === today.toLocaleDateString()) {
    return moment(date).format('h:mm a')
  } else if (date.toLocaleDateString() === yesterday.toLocaleDateString()) {
    if (status === 'list') return 'Yesterday'
    return 'Yesterday, ' + moment(date).format('h:mm a')
  }
  if (status === 'list') return moment(date).format('MMM D')

  if (moment(date).format('YYYY') === moment(today).format('YYYY')) { return moment(date).format('dddd, MMM D, h:mm a') }
  return moment(date).format('MMM, YYYY')
}

export const chatDateTime = (today, date) => {
  const times = [['second', 1], ['minute', 60], ['hour', 3600], ['day', 86400], ['week', 604800], ['month', 2592000], ['year', 31536000]]
  var diff = Math.round((today - date) / 1000)
  for (var t = 0; t < times.length; t++) {
    if (diff < times[t][1]) {
      if (t === 0) {
        return { min: 0 }
      } else {
        diff = Math.round(diff / 60)
        return { min: diff }
      }
    }
  }
}

export const secondsToTime = (secs) => {
  var hours = Math.floor(secs / (60 * 60))

  var divisor_for_minutes = secs % (60 * 60)
  var minutes = Math.floor(divisor_for_minutes / 60)

  var divisor_for_seconds = divisor_for_minutes % 60
  var seconds = Math.ceil(divisor_for_seconds)
  if (hours === 0) {
    return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
  }
  return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
}

export const detectURL = (string) => {
  var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig

  if (global.isNative && string.match(urlRegex) === null) return undefined
  return string.replace(urlRegex, (url) => {
    return `<a target="_blank" href="${url}" style="color: #0c0033;cursor: pointer;text-decoration: underline;">${url}</a>`
  })
}

export const phoneNumberFormate = (phone) => {
  if (phone.length >= 2) phone = phone.slice(0, 1) + '-' + phone.slice(1)
  if (phone.length >= 6) phone = phone.slice(0, 5) + '-' + phone.slice(5)
  if (phone.length >= 10) phone = phone.slice(0, 9) + '-' + phone.slice(9)
  return phone
}

export const IntConversation = (value) => {
  const suffixes = ['', 'k', 'm', 'b', 't']
  const suffixNum = Math.floor(('' + value).length / 3)
  const shortValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(2))
  return shortValue + suffixes[suffixNum]
}

export const getRolename = (value) => {
  value = Number(value)
  switch (value) {
    case 1: return localize.parent
    case 2: return localize.grandparent
    case 3: return localize.mentor
    case 4: return localize.teacher
    default: return localize.child
  }
}

export const ImageToBase64 = (url) => {
  return new Promise((resolve) => {
    try {
      if (window.Base64Img[url]) return resolve(window.Base64Img[url])
      var httpRequest = new XMLHttpRequest()
      httpRequest.onload = () => {
        var fileReader = new FileReader()
        fileReader.onloadend = () => {
          // console.log(fileReader.result);
          window.Base64Img = Object.assign(window.Base64Img || {}, { [url]: fileReader.result })
          resolve(fileReader.result)
        }
        fileReader.readAsDataURL(httpRequest.response)
      }
      httpRequest.open('GET', url)
      httpRequest.responseType = 'blob'
      httpRequest.send()
    } catch (error) {
      resolve(undefined)
    }
  })
}

export const audioToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      let encoded = reader.result.replace(/^data:(.*;base64,)?/, '')
      if ((encoded.length % 4) > 0) { encoded += '='.repeat(4 - (encoded.length % 4)) }
      resolve(encoded)
    }
    reader.onerror = error => reject(error)
  })
}

// Cookie

export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toGMTString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function checkCookie (cname) {
  var user = getCookie(cname)
  if (user !== '') {
    return true
  } else {
    return false
  }
}

export function deleteCookie (cname) {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}

export function showAlert (title, message) {
  if (Platform.OS === 'web') return alert(message)
  return Alert.alert(title, message)
}
